import { render, staticRenderFns } from "./EmbedImmersiveContent.vue?vue&type=template&id=5fa1cbec&scoped=true&"
import script from "./EmbedImmersiveContent.vue?vue&type=script&lang=js&"
export * from "./EmbedImmersiveContent.vue?vue&type=script&lang=js&"
import style0 from "./EmbedImmersiveContent.vue?vue&type=style&index=0&id=5fa1cbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1cbec",
  null
  
)

export default component.exports